import { INDENT_SIZE } from "./outdent.command";
import { isNestedListLi } from "./list-outdent.helper";

export const outdentBlocks = ({ blocks }) => {
  blocks.forEach((block) => {
    const currentPadding = parseInt(
      window.getComputedStyle(block).paddingLeft || "0",
    );
    const currentLevel = Math.floor(currentPadding / INDENT_SIZE);

    // Check if already at max indent level
    if (currentLevel <= 0) {
      return;
    }

    block.style.paddingLeft = `${currentPadding - INDENT_SIZE}px`;
  });
};

export const outdentList = ({ blocks }) => {
  if (!blocks || blocks.length === 0) {
    return;
  }

  // Group consecutive li elements that share the same parent nested list
  const groups = [];
  let currentGroup = [];
  let lastParent = null;

  blocks.forEach((li) => {
    const isNestedList = isNestedListLi({ li });

    // Skip if not nested - cannot outdent
    if (!isNestedList) {
      return;
    }

    const parent = li.parentNode;

    if (parent === lastParent && currentGroup.length > 0) {
      // Same parent, add to current group
      currentGroup.push(li);
    } else {
      // Different parent or first item, start new group
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }
      currentGroup = [li];
      lastParent = parent;
    }
  });

  // Don't forget the last group
  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  // Process each group
  groups.forEach((group) => {
    if (group.length === 0) return;

    const firstLi = group[0];
    const parentList = firstLi.parentElement; // nested ul or ol
    if (!parentList) return;

    const parentTag = parentList.tagName.toLowerCase();
    if (parentTag !== "ul" && parentTag !== "ol") return;

    const grandParent = parentList.parentElement; // outer ul or ol
    if (!grandParent) return;

    const gpTag = grandParent.tagName.toLowerCase();
    if (gpTag !== "ul" && gpTag !== "ol") return;

    // Find insertion point - after the nested list
    const insertionPoint = parentList.nextSibling;

    // Move all li elements in the group to outer list
    group.forEach((li) => {
      if (insertionPoint) {
        grandParent.insertBefore(li, insertionPoint);
      } else {
        grandParent.appendChild(li);
      }
    });

    // If nested list is now empty, remove it
    if (parentList.children.length === 0) {
      parentList.remove();
    }
  });
};
